import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';

export default function ProtectedRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return <div>Loading...</div>; // Or a nice spinner
    }

    if (!user) {
        return (
            <div className="container" style={{ textAlign: 'center', marginTop: '50px' }}>
                <h2 style={{ color: '#ef4444' }}>Access Denied</h2>
                <p>You do not have permission to view this page.</p>
                <p>Only administrators can view the event list.</p>
                <a href="/login" style={{ color: '#6366f1', textDecoration: 'underline' }}>Admin Login</a>
            </div>
        );
    }



    return children;
}
